import { createFileRoute } from "@tanstack/react-router";
import AdminRentals from "@/pages/admin/AdminRentals";

export const Route = createFileRoute("/_adminLayout/admin/rentals")({
  component: AdminRentals,
});
